export const checkUnsetViewers = (viewers) => viewers.some((viewer) => !viewer.hidden);
